<template>
  <Info />
</template>

<script>
import Info from '../modules/info.vue'
export default {
  components: { Info },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style scoped></style>
